import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useState } from 'react';

function Manage_Courseset_Modal({ isOpen, setIsAdd, addcourseset, id, editcourseset, token, rank, setRank, major, setMajor, cohort, setCohort, course, setCourse, allMajor, allCohort, allCourse }) {
  const [loading, setLoading] = useState(false);

  //#region functions
  // set name filed
  const handleRankChange = (e) => setRank(e.target.value)
  // form submit
  const onSubmit = async () => {

    if (loading) return;
    setLoading(true)
    let result

    try {
      // check and validation for name existence

      if (rank == '') {
        toast.error('Failed, rank is empty!')
        return
      }
      if (major.length == 0) {
        toast.error('Failed, major is empty!')
        return
      }
      if (cohort.length == 0) {
        toast.error('Failed, cohort is empty!')
        return
      }
      if (course.length == 0) {
        toast.error('Failed, course is empty!')
        return
      }
      const payload = {
        rank: Number(rank),
        offer: true,
        majorId: major[0]?.id ?? '-1',
        cohortId: cohort[0]?.id ?? '-1',
        courseId: course[0]?.id ?? '-1'
      }
      // if id exists it means we add data else edit data
      if (id == -1)
        result = await addcourseset(payload, token)
      else
        result = await editcourseset(payload, id, token)
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = id == -1 ? 'Data added successfully' : 'Data edited successfully'
        toast.success(msg)
        // disappear modal
        setIsAdd(false)
      }
    } catch (error) {
      const errmsg = error.response?.data?.message
      if (!errmsg)
        return

      // show error reason as an error toast 
      if (Array.isArray(errmsg)) {

        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element)
          }, 200 * index);
        });
      } else {
        toast.error(errmsg)
      }
    }
    finally {
      setLoading(false)
    }
  }


  //#endregion functions

  //#region render
  return (
    <Modal
      show={isOpen}
      // setIsAdd={setIsAdd}
      onHide={
        function () { setIsAdd(false) }
      }
      centered
    >
      <Modal.Header closeButton  >
        <Modal.Title>{id == -1 ? 'Add new data' : 'Edit data'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Form.Group >
          <Form.Label>Rank: </Form.Label>
          <Form.Control type="text" onChange={handleRankChange} value={rank} placeholder="Enter rank.." />
        </Form.Group>

        <Form.Group>
          <Form.Label>Major: </Form.Label>
          <Typeahead
            id="major-selection"
            labelKey="name"
            onChange={setMajor}
            options={allMajor.data}
            placeholder={`Choose a major...`}
            selected={major}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Cohort: </Form.Label>
          <Typeahead
            id="cohort-selection"
            labelKey="name"
            onChange={setCohort}
            options={allCohort.data}
            placeholder={`Choose a cohort...`}
            selected={cohort}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Course: </Form.Label>
          <Typeahead
            id="course-selection"
            labelKey="name"
            onChange={setCourse}
            options={allCourse.data}
            placeholder={`Choose a course...`}
            selected={course}
          />
        </Form.Group>

      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="primary" type="submit" onClick={() => {
          // this.props.isOpen = false;
          // return handleSubmit(name)
          // return;
          onSubmit()
        }}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
  //#endregion render
}

export default Manage_Courseset_Modal;